import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { BannerComponent } from './banner/banner.component';
import { ThemeService } from './services/theme.service';
import { LanguageService } from './services/language.service';
import { FooterComponent } from './footer/footer.component';
import { ToastComponent } from './toast/toast.component';
import { CookieConsentComponent } from './cookie-consent/cookie-consent.component';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    BannerComponent,
    FooterComponent,
    ToastComponent,
    CookieConsentComponent,
  ],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.component.css',
})
export class AppComponent {
  title = 'MyPlace';

  constructor(
    private themeService: ThemeService,
    private languageService: LanguageService,
  ) {}

  ngOnInit() {
    this.themeService.applyFromStorage();
    this.themeService.applyFromProfile();
    this.themeService.watchSystemTheme();
  }
}
